import React from 'react'
import { Pill } from '../../../../../shared/sso-workspace/pill'
import { LocalTime } from '../../../../../shared/date/local-time-view'
import { isInstant } from '../signin-method-words'

// Where a kind's configuration comes from (auth's configuration.source).
// Phase 1 has nothing to type for any kind: Microsoft is the shared
// EducationXR Entra app, the others read the platform settings (Google its
// own connection record) until each gets its own fields.
const SOURCE_LEDE = {
  shared_app: "EducationXR's shared app, from the platform settings: nothing to type here.",
  platform_settings: 'From the platform settings on the auth service: nothing to type here. Each one is set or missing; secret values are never shown.',
  anchor: 'From its own connection record, which an engineer sets: nothing to type here.'
}

// A kind's configuration, read only: auth's items (a value, or set/missing,
// and the platform setting it comes from) and its notes; then the kind's
// options as switches (Microsoft's who-can-sign-in), bound to the screen's
// edits and saved with Save.
export const MethodConfiguration = ({ method, label, settings, disabled, onSetting }) => {
  const configuration = method.configuration || {}
  const items = configuration.items || []
  const notes = configuration.notes || []
  const options = method.options || []

  return (
    <div className="d-grid gap-3">
      {SOURCE_LEDE[configuration.source] && <p className="sw-hint m-0">{SOURCE_LEDE[configuration.source]}</p>}
      {items.length > 0 &&
        <dl className="row g-2 m-0" data-testid="method-configuration">
          {items.map(item =>
            <React.Fragment key={item.label}>
              <dt className="col-sm-4 sw-label">{item.label}</dt>
              <dd className="col-sm-8 m-0">
                <ConfigValue item={item} />
                {item.setting && <span className="sw-hint d-block">Platform setting <code className="sw-mono">{item.setting}</code></span>}
              </dd>
            </React.Fragment>)}
        </dl>}
      {items.length === 0 && !SOURCE_LEDE[configuration.source] && <p className="sw-hint m-0">Nothing to configure.</p>}
      {notes.map(note => <p key={note} className="sw-hint m-0">{note}</p>)}

      {options.length > 0 &&
        <fieldset className="d-grid gap-2" data-testid="method-options">
          <legend className="sw-label fs-6 mb-1">{`Who can sign in with ${label}`}</legend>
          {options.map(option =>
            <div key={option.key} className="form-check form-switch">
              <input className="form-check-input" type="checkbox" role="switch" id={`option-${option.key}`}
                checked={Boolean(settings[option.key])} disabled={disabled}
                aria-describedby={option.help ? `option-${option.key}-help` : undefined}
                onChange={e => onSetting(option.key, e.target.checked)} />
              <label className="form-check-label fw-semibold" htmlFor={`option-${option.key}`}>{option.label}</label>
              {option.help && <div className="sw-hint" id={`option-${option.key}-help`}>{option.help}</div>}
            </div>)}
        </fieldset>}
    </div>
  )
}

const ConfigValue = ({ item }) => {
  if (item.value !== undefined && item.value !== null && item.value !== '') {
    return isInstant(item.value) ? <LocalTime value={item.value} /> : <code className="sw-mono text-break">{item.value}</code>
  }
  if (item.set === true) return <Pill tone="ok">Set</Pill>
  if (item.set === false) return <Pill tone="bad">Missing</Pill>
  return <span className="sw-hint">—</span>
}
